/**
 * Portal Edge static refund method translation keys (must match shopify-app RefundResolutionStaticTranslationKeys).
 * Used by Settings > Portal > Content > Refund Methods editor.
 */

export const REFUND_METHOD_STATIC_NAME_CREDITS = 'REFUND_METHOD_STATIC_CREDITS_NAME';

export const REFUND_METHOD_STATIC_DESC_CREDITS = 'REFUND_METHOD_STATIC_CREDITS_DESCRIPTION';

export const REFUND_METHOD_STATIC_NAME_GIFT_CARD = 'REFUND_METHOD_STATIC_GIFT_CARD_NAME';

export const REFUND_METHOD_STATIC_DESC_GIFT_CARD = 'REFUND_METHOD_STATIC_GIFT_CARD_DESCRIPTION';

export const REFUND_METHOD_STATIC_NAME_REFUND = 'REFUND_METHOD_STATIC_REFUND_NAME';

export const REFUND_METHOD_STATIC_DESC_REFUND = 'REFUND_METHOD_STATIC_REFUND_DESCRIPTION';

export const REFUND_METHOD_STATIC_NAME_BANK_REFUND = 'REFUND_METHOD_STATIC_BANK_REFUND_NAME';

export const REFUND_METHOD_STATIC_DESC_BANK_REFUND = 'REFUND_METHOD_STATIC_BANK_REFUND_DESCRIPTION';

export const REFUND_METHOD_STATIC_NAME_INSTANT_REFUND = 'REFUND_METHOD_STATIC_INSTANT_REFUND_NAME';

export const REFUND_METHOD_STATIC_DESC_INSTANT_REFUND = 'REFUND_METHOD_STATIC_INSTANT_REFUND_DESCRIPTION';

export const REFUND_METHOD_STATIC_NAME_NO_OFFERS = 'REFUND_METHOD_STATIC_NO_OFFERS_NAME';

export const REFUND_METHOD_STATIC_DESC_NO_OFFERS = 'REFUND_METHOD_STATIC_NO_OFFERS_DESCRIPTION';

export type RefundMethodStaticBlock = {
    id: string;
    blockTitle: string;
    nameKey: string;
    descriptionKey: string;
};

export const REFUND_METHOD_STATIC_BLOCKS: RefundMethodStaticBlock[] = [
    {
        id: 'credits',
        blockTitle: 'Store credit',
        nameKey: REFUND_METHOD_STATIC_NAME_CREDITS,
        descriptionKey: REFUND_METHOD_STATIC_DESC_CREDITS,
    },
    {
        id: 'gift-card',
        blockTitle: 'Gift card',
        nameKey: REFUND_METHOD_STATIC_NAME_GIFT_CARD,
        descriptionKey: REFUND_METHOD_STATIC_DESC_GIFT_CARD,
    },
    {
        id: 'refund',
        blockTitle: 'Original payment method',
        nameKey: REFUND_METHOD_STATIC_NAME_REFUND,
        descriptionKey: REFUND_METHOD_STATIC_DESC_REFUND,
    },
    {
        id: 'bank-refund',
        blockTitle: 'Bank transfer',
        nameKey: REFUND_METHOD_STATIC_NAME_BANK_REFUND,
        descriptionKey: REFUND_METHOD_STATIC_DESC_BANK_REFUND,
    },
    {
        id: 'instant-refund',
        blockTitle: 'Instant refund',
        nameKey: REFUND_METHOD_STATIC_NAME_INSTANT_REFUND,
        descriptionKey: REFUND_METHOD_STATIC_DESC_INSTANT_REFUND,
    },
    {
        id: 'no-offers',
        blockTitle: 'No refund offer',
        nameKey: REFUND_METHOD_STATIC_NAME_NO_OFFERS,
        descriptionKey: REFUND_METHOD_STATIC_DESC_NO_OFFERS,
    },
];

export function getAllRefundMethodStaticTranslationKeys(): string[] {
    return REFUND_METHOD_STATIC_BLOCKS.flatMap((b) => [b.nameKey, b.descriptionKey]);
}
